import { useMemo } from 'react';

import { usePrintsConfigStore } from '../stores';
import { useSelectedDeliveryOption } from './use-selected-delivery-option';
import { useSelectedFinish } from './use-selected-finish';

const useInvalidDeliveryOptionSelected = () => {
  const finishesByDeliveryOption = usePrintsConfigStore(
    (state) => state.availableFinishesByDeliveryOption,
  );
  const deliveryOption = useSelectedDeliveryOption();
  const finish = useSelectedFinish();

  return useMemo(() => {
    if (!deliveryOption || !finish || !finishesByDeliveryOption) {
      return false;
    }

    const availableFinishes = finishesByDeliveryOption[deliveryOption.key];

    // If there are no finishes for this delivery option, it's invalid.
    if (!availableFinishes) {
      return true;
    }

    // Check if the currently selected finish is not in the list of available finishes.
    return !availableFinishes.some((f) => f.key === finish.key);
  }, [deliveryOption, finish, finishesByDeliveryOption]);
};

export { useInvalidDeliveryOptionSelected };
